var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWomanHairstyle4B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Woman_x5F_hair:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x34_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x34_b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#85898B",
    d: "M402.6,70c-2.1-0.7-4.5-1.2-7.1-1.8c-4.1-0.8-8.6-1.5-13.4-2.1c-0.9-0.1-1.8-0.2-2.7-0.3 c-8.7-0.8-18-1.1-26.8-0.7c-0.8,0-1.5,0.1-2.3,0.1c-5.5,0.3-10.6,1-15.2,1.9c-0.4,0.1-0.8,0.2-1.2,0.2c-1.1,0.2-2.2,0.5-3.4,0.7 c-9.5,2.1-19,5-27.2,10.4c-0.5,0.3-1,0.7-1.5,1.1c-2.7,2-5.4,4-7.5,6.4c36.1-21,81-22.3,119-7.6C411.2,73.9,407.7,71.6,402.6,70z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#484D4D",
    d: "M291.2,98.9c1,3.3,3.2,6.1,5.6,7.9c5.9-3.7,12-6.8,18.3-9.2c6.3-2.4,12.7-4.3,19.3-5.6 c4.9-1,9.9-1.7,15-2c5-0.4,10.1-0.4,15.1-0.1c13.9,0.8,27.4,4.2,39.9,10c0.6-0.2,1.2-0.5,1.8-0.8 C372.3,77.2,324.8,73.5,291.2,98.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484D4D",
    d: "M398.6,29.6c-2.4-0.6-5-0.7-8-0.2c-0.1-0.3-0.3-0.6-0.5-0.9c-1,10-3.5,26.1-10.8,37.4 c0.9,0.1,1.8,0.2,2.7,0.3C390.3,59.4,398.7,42.4,398.6,29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484D4D",
    d: "M364.6,20.4c-2.8,1-5.6,2.5-8,4.7c-0.2,13.4-2.3,28.5-6.2,40.2c0.7,0,1.5-0.1,2.3-0.1 C362.2,53.9,365.1,32.4,364.6,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484D4D",
    d: "M330.5,68.2c1.1-0.3,2.3-0.5,3.4-0.7c-9.1-10.1-16.3-23-17-36.2c0,0.1,0,0.2,0,0.2 c-2.6-0.1-5.2,0.1-7.7,0.7C310.1,48.2,320.5,61.8,330.5,68.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#707474",
    d: "M410.3,39.2c-2.5-4.5-6.4-8.2-11.7-9.6c0,12.8-8.3,29.8-16.6,36.5c4.8,0.5,9.3,1.2,13.4,2.1 c2.6,0.5,5,1.1,7.1,1.8c2.1-1.9,5-5.8,6.2-7.3C412.5,57.6,414.4,46.5,410.3,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707474",
    d: "M364.6,20.4c0.5,12.1-2.4,33.6-12,44.8c8.8-0.4,18.1-0.1,26.8,0.7c7.2-11.3,9.7-27.3,10.8-37.4 C385.8,21.1,374.7,17,364.6,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707474",
    d: "M356.3,25.3c-7.7-12.4-37.7-8.7-39.4,6c0.7,13.1,7.9,26,17,36.2c0.4-0.1,0.8-0.2,1.2-0.2 c4.6-0.9,9.8-1.6,15.2-1.9c3.9-11.7,6-26.8,6.2-40.2C356.5,25.2,356.4,25.2,356.3,25.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707474",
    d: "M309.2,32.2c-3.8,0.8-7.3,2.5-10.3,5.2c-7,6.5-9.1,14.7-7.5,23.6c1.6,9.2,5.3,12.5,11.9,17.6 c8.2-5.4,17.7-8.3,27.2-10.4C320.5,61.8,310.1,48.2,309.2,32.2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ABFF7F",
    strokeWidth: 0.1064,
    d: "M437.1,185.2L437.1,185.2C437.1,185.2,437.2,185.2,437.1,185.2 C437.3,185.1,437.2,185,437.1,185.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M463.9,180.7c0-1.9,0-3.7-0.2-5.5l0,0C463.9,176.9,463.9,178.8,463.9,180.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M429.1,115.6c-0.9-0.8-1.9-1.5-2.8-2.3C427.3,114,428.2,114.8,429.1,115.6L429.1,115.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M423.5,111.2c0.8,0.6,1.7,1.3,2.5,1.9C425.2,112.4,424.4,111.8,423.5,111.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M463.9,180.7c0,0.1,0,0.3,0,0.4C463.9,180.9,463.9,180.8,463.9,180.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M423,110.8c0.2,0.1,0.4,0.3,0.5,0.4C423.4,111,423.2,110.9,423,110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85898B",
    d: "M455.3,148.3c-6.5-12.7-15.5-23.7-26.1-32.7l0,0c-0.9-0.8-1.8-1.5-2.8-2.3c-0.1-0.1-0.2-0.2-0.3-0.2 c-0.8-0.6-1.7-1.3-2.5-1.9c-0.2-0.1-0.3-0.3-0.5-0.4c-5.8-4.2-12-7.9-18.6-10.9c-12.4-5.8-25.9-9.2-39.9-10 c-5-0.3-10.1-0.3-15.1,0.1s-10,1-15,2c-6.6,1.3-13.1,3.2-19.3,5.6c-6.3,2.4-12.4,5.5-18.3,9.2c-22.6,14.1-41.2,36.6-48.1,62.2 c-1.8,11.1-1.1,23,6.3,28.3c3.8,2.7,9.2,4.1,13.6,2.7c1.4-1.7,2.4-4,2.6-6.4c-4.2-20.6-5.3-44.8,10.1-61.1 c-13.4,20.8-8.2,46.7-6,59.8c7.8-0.5,11.8-9.6,12.3-18.5c-0.8-21.2,1.1-49.2,21.7-65.4c-15.8,18.2-20.3,40.8-18,63.1 c10.6,0.4,19.5-5.8,21.7-14.4l0.1,0.1c-2.4-18.7-1.3-42.5,13.9-56.7c-10.3,13.1-15.2,40-9.6,59.6c5.9,2,13.2-1.5,15.4-6.3 c0.1,0.1,0.2,0.2,0.3,0.3c-2.8-18.7,0.6-41.4,11.1-56.7c-4.9,12.4-12.1,29.6-7.9,58.5c4.1,1,9.5-0.9,12.2-3.4 c0.1,0.2,0.2,0.5,0.3,0.7c-1.6-19.4,1.6-40.5,13.4-55.8c-9.2,17.8-12.3,39.7-9.2,60.1c5.1,2.7,12.7,2.1,15.9-2.8 c5.8-18.4,6.6-38.8,2.9-57.3c7.4,16.9,5.3,40.7-0.1,59.2c3.7,3.3,9.2,4.2,13.8,2.6c6.4-18.7,6.3-42.9,2.6-57 c7.5,15.6,6.4,36.5,1.9,54.1c0,0,0,0,0.1-0.1c0.7,4.4,6.5,10.3,10.4,11.9c4.5,1.9,7.6,2,11.9,0.5c4-20.3-0.1-46.4-4.4-54.3 c11.1,13.9,10.8,37.4,8,52.8c0.1,0,0.1-0.1,0.2-0.1c0.2,10.7,8.8,19.2,16.4,19.3c7.8-20.1,2.7-45.7-3.3-60.7 c13,20.2,13,45.5,7.6,61.3c-1.7,10.8,6.5,15.1,10.8,15.6c0.6,0.1,1.1,0.1,1.7,0.1c7.9-0.3,12.6-8.9,14-14.9 c0.1-0.3,0.1-0.6,0.2-0.9c0.3-1.9,0.4-3.8,0.4-5.7c0-0.1,0-0.3,0-0.4c0-1.9-0.1-3.7-0.2-5.5l0,0c-0.9-9.5-4.3-18.5-8.5-26.8 L455.3,148.3L455.3,148.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5C605F",
    d: "M406.2,99.1c5-2.5,9.6-7.6,8.9-13.5c-0.3-2.8-1-5.1-1.8-7.1c-38.1-14.7-82.9-13.3-119,7.6 c-2.2,2.6-3.7,5.5-3.6,9.3c0,1.2,0.2,2.4,0.5,3.6C324.8,73.5,372.3,77.2,406.2,99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C605F",
    d: "M255.1,201.5c-3.6-1.9-5.8-5.6-7.1-9.9c-11.2,3.3-14.6,21-3.2,28.2c-8.1,12.8,1.5,28.5,14.3,30.7 c7.4,1.1,11.2-5,11.3-12.5c0.5-4.3-2.1-10.8-6.2-11.6c6.4-6.1,5.9-18.2-0.7-23.8C260.8,203.2,258,203,255.1,201.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C605F",
    d: "M449.6,201.5c-6,6.5-6.9,19.7,4.5,23.8c-3.2,3.4-5.6,9.6-5.1,14c0.4,3.5,5,8.8,8.7,7.6 c8.9,1.1,15.2-7.8,18.4-14.5c3.2-7.8,4.3-20.1-3-25.4c8.6-6.4,3-18.7-9.4-21.6C462.2,192,457.5,201.3,449.6,201.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C605F",
    d: "M477.8,181.6c-11.4-11.8-11.9-29.1-23-41.3c12,3.3,22.8,10.7,25.4,23.3c2.4-3.4-0.1-16.2-1.6-20.4 c-2.2-6.3-5.2-9.4-10.6-13.6c-6.8-5.3-15.1-7.4-23.1-9.4c-4.8-1.2-10.4-2.7-15.8-4.7c10.6,9,19.6,20,26.1,32.7h-0.1 c4.3,8.4,7.7,17.3,8.5,26.8c4.5,4.7,11.8,6.4,17.1,8.6C479.6,183.2,478.7,182.5,477.8,181.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M426,113.1c0.1,0.1,0.2,0.2,0.3,0.2C426.2,113.2,426.1,113.1,426,113.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00C200",
    d: "M437.1,185.2L437.1,185.2C437.1,185.2,437.2,185.2,437.1,185.2C437.3,185.1,437.2,185,437.1,185.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AAA39F",
    d: "M255.1,197.2c-7.4-5.3-8.1-17.2-6.3-28.3c-1.3,4.7-2.1,9.5-2.5,14.4c0,3.3,0.4,6.7,1.4,9.9 c1.3,4,3.5,7.5,7.1,9.3c2.9,1.4,5.8,1.7,8.3,1c2.2-0.6,4.2-1.9,5.6-3.6C264.2,201.3,258.8,199.9,255.1,197.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAA39F",
    d: "M271.3,193.5c0.1-0.6,0.1-1.2,0-1.8c1.5,0.4,2.8,0.6,4.1,0.5c-2.2-13.1-7.5-38.9,6-59.8 C265.9,148.7,267.1,172.8,271.3,193.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAA39F",
    d: "M429.2,125.6c6,15,11,40.6,3.3,60.7c1.6,0,3.2-0.3,4.6-1.1l0,0c0-0.1,0.1-0.1,0,0l0,0 c-0.1,0.6-0.3,1.2-0.3,1.7C442.2,171.1,442.2,145.8,429.2,125.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAA39F",
    d: "M412.3,168.5c1.1-0.4,2.3-0.9,3.6-1.4c2.8-15.4,3.1-38.9-8-52.8C412.3,122.1,416.3,148.2,412.3,168.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAA39F",
    d: "M287.6,173.6c0.1-0.9,0.1-1.8,0.1-2.6c1.2,0.2,2.5,0.3,3.7,0.4c-2.3-22.4,2.2-44.9,18-63.1 C288.8,124.4,286.8,152.4,287.6,173.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAA39F",
    d: "M333.2,153.9c0.9,0.9,2,1.5,3.2,1.8c-4.2-28.9,3-46.2,7.9-58.5C333.8,112.5,330.4,135.2,333.2,153.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAA39F",
    d: "M313.1,157.1c1.3,1.4,2.8,2.4,4.3,2.9c-5.6-19.6-0.7-46.5,9.6-59.6C311.9,114.6,310.7,138.4,313.1,157.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAA39F",
    d: "M368.9,154.5c0.2-0.3,0.3-0.5,0.5-0.8c0.6,1,1.4,1.9,2.3,2.7c5.3-18.5,7.5-42.3,0.1-59.2 C375.5,115.7,374.7,136.2,368.9,154.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAA39F",
    d: "M385.5,159c1.7-0.6,3.3-1.6,4.5-2.9c4.5-17.6,5.6-38.5-1.9-54.1C391.7,116.1,391.9,140.3,385.5,159z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAA39F",
    d: "M348.8,153c0.8,1.8,2.3,3.3,4.2,4.3c-3.1-20.3-0.1-42.2,9.2-60.1C350.4,112.6,347.2,133.6,348.8,153z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AAA39F",
    d: "M463.7,175.1L463.7,175.1c-0.3-3.9-1.1-7.7-2.2-11.4c1.7,8.1,1.9,16.7-0.7,23.6 c-2.3,6.2-8.4,13.1-15.2,14.8c0.7,0.2,1.4,0.4,2,0.4c0.6,0.1,1.1,0.1,1.7,0.1c7.9-0.3,12.6-8.9,14-14.9 c0.1-0.3,0.1-0.6,0.2-0.9c0.3-1.9,0.4-3.8,0.4-5.7c0-0.1,0-0.3,0-0.4C463.9,178.8,463.9,176.9,463.7,175.1z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanHairstyle4B);
export default __webpack_public_path__ + "static/media/woman_hairstyle_4b.4ea9236f990bc62ebf01f8dfb360defc.svg";
export { ForwardRef as ReactComponent };